var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 15.4497L12.4999 28.7631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 15.4497L12.4999 28.7631",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7425 3.429C16.8354 3.42901 16.9274 3.41073 17.0131 3.3752C17.0989 3.33967 17.1769 3.28759 17.2426 3.22193C17.3082 3.15626 17.3603 3.0783 17.3958 2.99251C17.4314 2.90671 17.4497 2.81476 17.4496 2.72189L17.4496 1.60042C17.4496 1.33526 17.3442 1.08096 17.1567 0.893465C16.9692 0.705965 16.715 0.600611 16.4498 0.600571L8.54999 0.600572C8.28483 0.600612 8.03054 0.705966 7.84304 0.893466C7.65554 1.08096 7.55019 1.33526 7.55015 1.60042L7.55014 2.72189C7.55013 2.81476 7.56841 2.90671 7.60394 2.99251C7.63947 3.0783 7.69156 3.15626 7.75722 3.22192C7.82288 3.28759 7.90084 3.33967 7.98664 3.3752C8.07243 3.41073 8.16439 3.42901 8.25725 3.429C8.35011 3.42899 8.44207 3.44727 8.52787 3.4828C8.61366 3.51833 8.69162 3.57041 8.75728 3.63607C8.82295 3.70174 8.87503 3.7797 8.91056 3.86549C8.94609 3.95129 8.96437 4.04324 8.96436 4.13611L8.96436 10.0857C8.9644 10.3509 8.8591 10.6052 8.67162 10.7928L6.42867 13.0358C6.24119 13.2233 6.13589 13.4777 6.13593 13.7429L6.13593 14.45C6.13597 14.7151 6.24133 14.9694 6.42883 15.1569C6.61632 15.3444 6.87062 15.4498 7.13578 15.4498L17.864 15.4498C18.1292 15.4498 18.3835 15.3444 18.571 15.1569C18.7585 14.9694 18.8638 14.7151 18.8639 14.45V13.7429C18.8639 13.4777 18.7586 13.2233 18.5711 13.0358L16.3289 10.7935C16.1414 10.606 16.0361 10.3516 16.0361 10.0864L16.0361 4.13681C16.036 4.04395 16.0542 3.95198 16.0897 3.86614C16.1251 3.78031 16.1771 3.7023 16.2427 3.63657C16.3083 3.57084 16.3862 3.51868 16.472 3.48307C16.5577 3.44745 16.6497 3.42908 16.7425 3.429V3.429Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.7dc1745f.svg";
export { ForwardRef as ReactComponent };